import { render, staticRenderFns } from "./serviciosSuc.vue?vue&type=template&id=338dabb6&scoped=true"
import script from "./serviciosSuc.vue?vue&type=script&lang=js"
export * from "./serviciosSuc.vue?vue&type=script&lang=js"
import style0 from "./serviciosSuc.vue?vue&type=style&index=0&id=338dabb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338dabb6",
  null
  
)

export default component.exports